// extracted by mini-css-extract-plugin
export default {"container":"AttributionComponent_container__KueFS","innerContainer":"AttributionComponent_innerContainer__3+NTY"};